import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';
import type { BillingPlanTierId } from '@/constants/billingPlanTiers';

const endPoint = 'billing/attachPlan';
const url = apiUrl + endPoint;

export interface AttachPlanResponse {
  PaymentUrl: string;
  CustomerId: string;
  Error: string;
}

function parseAttachPayload(raw: unknown): AttachPlanResponse | undefined {
  try {
    if (typeof raw === 'string') {
      return JSON.parse(raw) as AttachPlanResponse;
    }
    if (raw !== null && typeof raw === 'object') {
      return raw as AttachPlanResponse;
    }
  } catch {
    return undefined;
  }
  return undefined;
}

/**
 * Attach an Autumn-backed plan (tier). Opens returned PaymentUrl when checkout is required.
 */
export async function attachPlan(
  organizationUUID: string,
  planId: BillingPlanTierId,
  headerObj: headerObject
): Promise<AttachPlanResponse | undefined> {
  const res = await postWithAuth(
    url,
    {
      OrganizationUUID: organizationUUID,
      PlanId: planId,
    },
    {
      headers: {
        ...headerObj,
      },
    }
  );

  if (!res.ok) {
    throw new Error(`attachPlan failed: HTTP ${res.status}`);
  }

  const raw: unknown = await res.json();
  return parseAttachPayload(raw);
}
